<template>
  <div class="attachments">
    <div class="existing-attachments" v-if="document && document.documentAttachments.length > 0">
      <div class="attachments-header">Priponke:</div>
      <ul class="attachments-list">
        <li class="attachment" v-for="attachment in document.documentAttachments" :key="attachment.id">
          <a class="attachment-url" :href="attachment.fileUrl" target="_blank">{{ attachment.name }}</a>
        </li>
      </ul>
    </div>
    <div class="add-attachment" v-if="document && document.allowUserAttachments">
      <div v-for="(attachment, index) in this.form.attachments" :key="attachment.frontendId">
        <br />
        <div :style="{ display: 'flex', 'justify-content': 'space-between' }">
          <div class="md-subheading">priloga {{ index + 1 }}</div>
          <v-button size="small" class="md-icon-button" @click="removeAttachment(index)">
            <v-tooltip>Ostrani prilogo</v-tooltip>
            <v-icon>close</v-icon>
          </v-button>
        </div>
        <div>
          <v-field>
            <label>Datoteka</label>
            <r-file-upload
              :model="attachment.fileModel"
              :file-upload-prefix="'finalized_document_attachments'"
              :accepts="['application/pdf']"
              @change="handleFileChange($event, index)"
            />
          </v-field>
        </div>
      </div>
      <div class="add-attachment-button">
        <v-button size="small" outlined @click="addAttachment">DODAJ PRILOGO</v-button>
        <icon class="add-attachment-button-help" name="question-mark" :width="18" :height="18" />
        <v-tooltip md-direction="bottom">Vzorec omogoča dodajanje prilog. S klikom na gumb lahko dodate eno ali več prilog, ki bodo pripete na konec vzorca.</v-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
import VButton from 'design-system/VButton.vue'
import VField from 'design-system/VField.vue'
import Icon from 'design-system/icons/Icon.vue'
import VIcon from 'design-system/VIcon.vue'
import VTooltip from 'design-system/VTooltip.vue'
import RFileUpload from 'design-system/components/RFileUpload.vue'

export default {
  components: {
    Icon,
    VButton,
    VField,
    VIcon,
    VTooltip,
    RFileUpload,
  },
  props: {
    document: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      form: {
        attachments: [],
      },
    }
  },
  watch: {
    form: {
      handler (newFormValue) {
        this.$emit('change', newFormValue)
      },
      deep: true,
    },
    document: {
      handler (newDocumentValue) {
        if (!newDocumentValue.userDocumentAttachments || !this.form.attachments || newDocumentValue.userDocumentAttachments.length === this.form.attachments.length) {
          return
        }

        const attachments = newDocumentValue.userDocumentAttachments.map(a => {
          return {
            ...a,
            fileModel: a,
          }
        })
        this.form.attachments = attachments
      },
      deep: true,
    },
  },
  methods: {
    handleFileChange (fileModel, index) {
      const attachment = this.form.attachments[index]

      if (fileModel && fileModel.blobHash) {
        attachment.name = fileModel.name
        attachment.blobHash = fileModel.blobHash
        attachment.contentType = fileModel.type
      } else {
        attachment.name = ''
        attachment.blobHash = null
        attachment.contentType = null
      }
    },
    addAttachment () {
      const newAttachment = {
        frontendId: Math.random().toString(36),
        name: '',
        fileModel: {},
        blobHash: null,
        contentType: null,
      }
      this.form.attachments.push(newAttachment)
    },
    removeAttachment (index) {
      this.form.attachments.splice(index, 1)
    },
  },
}
</script>

<style lang="scss" scoped>
@import 'app/assets/stylesheets/variables';

.attachments {
  .md-subheading {
    padding-top: 8px;
  }

  .md-field {
    padding-top: 0;
    margin-top: 0;
    margin-bottom: 0;
  }
}

.attachments-header {
  font-weight: 600;
}

.attachments-list {
  margin: 8px 0 0 0;
}

.attachment-url.attachment-url {
  color: $primary-blue;

  &:hover {
    color: $primary-blue;
  }
}

.add-attachment-button {
  display: flex;
  width: fit-content;
  padding: 16px 0;
}

.add-attachment-button-help {
  margin: 6px 0 0 16px;
}
</style>
